import PrivacyInfoCategoryContent from '../PrivacyFormFolder/PrivacyInfoCategoryContent';
import { useGetCategories } from 'hooks/Categories';
import SectionHeader from '../SparkSectionHeader';
import { Divider } from '@mui/material';

function SparkCategoryDetails() {
  const { dropdownOptions: categoriesOptions, isLoading: isLoadingCategories } =
    useGetCategories();

  if (isLoadingCategories) {
    return <>loading</>;
  }
  return (
    <>
      <Divider
        sx={{ width: '100%', marginTop: '20px', marginBottom: '20px' }}
      />
      <SectionHeader headerText='Category' />
      <PrivacyInfoCategoryContent categoriesOptions={categoriesOptions} />
    </>
  );
}

export default SparkCategoryDetails;
